module.exports = __webpack_public_path__ + "static/img/bk.ef3938d.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/diwali/bk.webp
// module id = R6ni
// module chunks = 0